// extracted by mini-css-extract-plugin
export default {"foundation":"RolesDescription_foundation__ErDgo","container":"RolesDescription_container__p3rRm","innerContainer":"RolesDescription_innerContainer__-6PVw"};